// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fuse-sidebar {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  position: absolute;
  top: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  z-index: 1000;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
}
@media screen and (max-width: 599px) {
  fuse-sidebar {
    min-width: 0 !important;
    max-width: 80vw !important;
    width: 80vw !important;
  }
}
fuse-sidebar.left-positioned {
  left: 0;
  transform: translateX(-100%);
}
fuse-sidebar.right-positioned {
  right: 0;
  transform: translateX(100%);
}
fuse-sidebar.open {
  transform: translateX(0);
}
fuse-sidebar.locked-open {
  position: relative !important;
  transform: translateX(0) !important;
}
fuse-sidebar.folded {
  position: absolute !important;
  top: 0;
  bottom: 0;
}
fuse-sidebar.animations-enabled {
  transition-property: transform, width, min-width, max-width;
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

.fuse-sidebar-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/sidebar/sidebar.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,2CAAA;AADJ;ACkBQ;ED/BR;IAiBQ,uBAAA;IACA,0BAAA;IACA,sBAAA;EAAN;AACF;AAEI;EACI,OAAA;EACA,4BAAA;AAAR;AAGI;EACI,QAAA;EACA,2BAAA;AADR;AAII;EACI,wBAAA;AAFR;AAKI;EACI,6BAAA;EACA,mCAAA;AAHR;AAMI;EACI,6BAAA;EACA,MAAA;EACA,SAAA;AAJR;AAOI;EACI,2DAAA;EACA,0BAAA;EACA,uCAAA;AALR;;AASA;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AANJ","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\nfuse-sidebar {\n    display: flex;\n    flex-direction: column;\n    flex: 1 0 auto;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch;\n    width: 280px;\n    min-width: 280px;\n    max-width: 280px;\n    z-index: 1000;\n    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);\n\n    @include media-breakpoint('xs') {\n        min-width: 0 !important;\n        max-width: 80vw !important;\n        width: 80vw !important;\n    }\n\n    &.left-positioned {\n        left: 0;\n        transform: translateX(-100%);\n    }\n\n    &.right-positioned {\n        right: 0;\n        transform: translateX(100%);\n    }\n\n    &.open {\n        transform: translateX(0);\n    }\n\n    &.locked-open {\n        position: relative !important;\n        transform: translateX(0) !important;\n    }\n\n    &.folded {\n        position: absolute !important;\n        top: 0;\n        bottom: 0;\n    }\n\n    &.animations-enabled {\n        transition-property: transform, width, min-width, max-width;\n        transition-duration: 150ms;\n        transition-timing-function: ease-in-out;\n    }\n}\n\n.fuse-sidebar-overlay {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 999;\n    opacity: 0;\n}","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
